import { render, staticRenderFns } from "./costo.vue?vue&type=template&id=90905c24&scoped=true&"
import script from "./costo.vue?vue&type=script&lang=js&"
export * from "./costo.vue?vue&type=script&lang=js&"
import style0 from "./costo.vue?vue&type=style&index=0&id=90905c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90905c24",
  null
  
)

export default component.exports